// TODO: Refactor this file with golden-layout typings
import { RuntimeType } from '@mae/app-engine-api/interfaces/runtime';
import { BrowserClientContentClient, FeatureAnalyzerClient } from '@mae/client-web/clients';
import { MetadataClient } from '@mae/client-web/metadata-client';
import { IAnalyzerViewListItem, IMapViewListItem } from '@mae/client-web/models';
import * as GoldenLayout from 'golden-layout';

export type StorageType = 'apps_storage' | 'studio_storage';

let mapViewsResove: (value?: IMapViewListItem[] | PromiseLike<IMapViewListItem[]>) => void;
const mapViewsPromise: Promise<IMapViewListItem[]> = new Promise((res) => {
	mapViewsResove = res;
});

let featureAnalyzerAppsResove: (value?: IAnalyzerViewListItem[] | PromiseLike<IAnalyzerViewListItem[]>) => void;
const featureAnalyzerAppsPromise: Promise<IAnalyzerViewListItem[]> = new Promise((res) => {
	featureAnalyzerAppsResove = res;
});

let goldenLayout: GoldenLayout;

export function setGoldenLayout(_goldenLayout: GoldenLayout): GoldenLayout {
	return (goldenLayout = _goldenLayout);
}

export function getParametersByName(name: string, url?: string): string {
	let actualUrl = url;
	if (!url) {
		actualUrl = window.location.href;
	}

	const actualName = name.replace(/[[\]]/g, '\\$&');
	const regex = new RegExp('[?&#]' + actualName + '(=([^&#]*)|&|#|$)', 'i');
	const results = regex.exec(actualUrl);

	if (!results) {
		return null;
	}

	return decodeURIComponent(results[results.length - 1].replace(/\+/g, ' '));
}

export async function fetchAssets(storage: StorageType, tenant: string): Promise<void> {
	MetadataClient.initialize(storage, tenant);

	if (storage == 'studio_storage') {
		mapViewsResove(await BrowserClientContentClient.getMapViews());
		featureAnalyzerAppsResove(await FeatureAnalyzerClient.getViews());
	}
}

export function getMapViews(): Promise<IMapViewListItem[]> {
	return mapViewsPromise;
}

export function getFeatureAnalyzerApps(): Promise<IAnalyzerViewListItem[]> {
	return featureAnalyzerAppsPromise;
}

export function timeout(ms = 0): Promise<NodeJS.Timeout> {
	return new Promise((resolve) => setTimeout(resolve, ms));
}

export function getAllComponent(): Array<unknown> {
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	return (goldenLayout._getAllContentItems() as Array<unknown>).filter((c) => c.type == 'component');
}

export function getAppTypeCount(appType: RuntimeType): number {
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	const components = getAllComponent(goldenLayout);
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	return components.filter((c) => c?.config?.componentName == appType).length;
}

export function isTitleUnique(title: string): boolean {
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	const components = getAllComponent(goldenLayout);
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	return components.filter((c) => c.title == title).length == 0;
}
